import React from 'react';

import { Box, Typography } from '@mui/material';

import { PaymentHistoryTable } from 'src/components/account';
import { useVerifierParamId } from 'src/hooks/verifier';
import { SxProp } from 'src/types/mui';

export const PaymentHistoryTab: React.FC = () => {
  const verifierId = useVerifierParamId();

  return verifierId ? (
    <PaymentHistoryTable verifierId={verifierId} useCurrentUser={false} showRefundAction />
  ) : (
    <Box sx={boxStyles}>
      <Typography component={Box} variant="h6">
        No data found
      </Typography>
    </Box>
  );
};

const boxStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
};
